import { createContext } from "react";

import type { SnackbarContextValue } from "./SnackbarContextValue";

export const SnackbarContext = createContext<SnackbarContextValue | null>(null);

SnackbarContext.displayName = "SnackbarContext";
